import React, { useRef, useEffect } from 'react';
import { ChatCircle, PaperPlaneTilt } from '@phosphor-icons/react';
import { Input } from '../ui/input';

/**
 * Live-stream chat panel.
 * Auto-scrolls to the newest message and submits on Enter via form.
 */
const ChatPanel = ({ messages, chatInput, setChatInput, onSend, isConnected }) => {
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex flex-col h-full" data-testid="live-chat-panel">
      <div className="px-4 py-3 border-b border-white/5 flex items-center gap-2">
        <ChatCircle weight="fill" className="w-4 h-4 text-blue-400" />
        <span className="text-sm font-bold text-white uppercase tracking-wider">Live Chat</span>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-2 space-y-2 min-h-0">
        {messages.map((msg, i) => (
          <div key={msg.id || msg.timestamp || `${msg.user_name}-${i}`} className="text-sm">
            <span className={`font-semibold ${msg.is_broadcaster ? 'text-blue-400' : 'text-amber-300'}`}>
              {msg.user_name}
            </span>
            <span className="text-slate-300 ml-1.5">{msg.message}</span>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>
      <form
        onSubmit={(e) => { e.preventDefault(); onSend(); }}
        className="px-3 py-3 border-t border-white/5 flex gap-2"
      >
        <Input
          value={chatInput}
          onChange={(e) => setChatInput(e.target.value)}
          placeholder={isConnected ? 'Say something...' : 'Connecting...'}
          disabled={!isConnected}
          className="bg-slate-800/60 border-white/10 text-sm flex-1"
          data-testid="chat-input"
        />
        <button
          type="submit"
          disabled={!isConnected || !chatInput.trim()}
          className="p-2 bg-blue-500 rounded-lg text-white disabled:opacity-40 hover:bg-blue-600 transition-colors"
          data-testid="chat-send-btn"
        >
          <PaperPlaneTilt weight="fill" className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
};

export default ChatPanel;
